<template>
    <v-app
            id="layout"
            :class="embedded ? 'embedded' : ''">
        <Alerts v-if="ready" />
        <Views v-if="ready" />
        <Footer v-if="ready" />
        
        <LoadingIndicator />
    </v-app>
</template>

<style>
  @import url(/console/theme/vuetify.css);

  html.overflow-y-hidden {
    -webkit-touch-callout: none;
    -webkit-user-callout: none;
    -webkit-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-modify: none;
    -webkit-highlight: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: manipulation !important;
  }
  @media only screen
  and (max-width: 1000px) {
      .v-menu__content {
        min-width: 70% !important;
      }
  }
</style>
<script>
    import LoadingIndicator from "./components/LoadingIndicator";
    import Views from "./components/Views";
    import Footer from "./components/Footer";
    import Alerts from "./components/Alerts";

    export default {
        name: 'Layout',
        components: {
            Views,
            Footer,
            LoadingIndicator,
            Alerts
        },
        data() {
            return {
                loading: this.$services.modals.loading.show(),
                ready: false,
            };
        },
        computed: {
            embedded() {
                return this.$route.fullPath.endsWith('embedded/iframe');
            }
        },
        created() {
            this.$router.onReady(() => {
                this.ready = true;
                this.loading.hide();
            });
        }
    };
</script>